<template>
  <div>
    <EpisodeFull :path="$route.path" />
  </div>
</template>
